// Mirrors: App\Enums\CurrencyTypes (core)
export const CurrencyType = Object.freeze({
    COINS: 'coins',
    IOS: 'ios',
    ANDROID: 'android',
});

// The store-backed currency types that require a native purchase and receipt
// validation. Mirrors CurrencyTypes::isStore() on the backend.
export const STORE_CURRENCY_TYPES = Object.freeze([CurrencyType.IOS, CurrencyType.ANDROID]);

export function isStoreCurrencyType(currencyType) {
    return STORE_CURRENCY_TYPES.includes(currencyType);
}
